import { useParams } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { Status } from '@bitcine/cinesend-theme/dist'
import Asset from '../../components/asset'
import AssetsByType from '../../components/assets_table'

const Ads = () => {
  const params = useParams()
  const { data: cycle, isLoading, error } = useQuery(['cycles/', params.cycleID])

  // If we have an assetID param, show the Asset component
  if (params.assetID) {
    return (
      <Status pending={isLoading} error={error}>
        <Asset cycle={cycle} listPath={`/airlines/${params.airlineID}/cycles/${params.cycleID}/ads/assets`} />
      </Status>
    )
  }

  // Otherwise show the assets list
  return (
    <Status pending={isLoading} error={error}>
      <AssetsByType cycle={cycle} assetType={{ value: 'ad', label: 'Ad', plural_label: 'Ads' }} />
    </Status>
  )
}

export default Ads
